<script>
export default {
    props: {
        element: {
            type: String,
            required: true
        },
        padding: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            attrs: {
                class: this.padding ? 'box box--padding' : 'box'
            }
        }
    },
    render(createElement) {
        return createElement(this.element, { attrs: this.attrs }, this.$slots.default)
    }
}
</script>

<style lang="scss">
.box {
    overflow: hidden;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(#000000, 0.2);
    &--padding {
        padding: 1rem;
    }
}
</style>
